import {
  FaDatabase,
  FaExchangeAlt,
  FaCogs,
  FaBolt,
} from "@onemind-services-llc/react-icons-ng/fa";
import HeroBg from "public/marketplace-apps/hero/Hero-section-mysql.png";

export const MySQL_CONSTANTS = {
  HERO: {
    title: "OneMind Services — MySQL (One-Click Application) ",
    desc: "Deploy MySQL, the world’s most popular open-source relational database management system.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "MySQL is a widely used open-source relational database management system (RDBMS). It is known for its reliability, high performance, and ease of use. MySQL is ideal for transactional applications, content management systems, and analytical workloads, supporting standard SQL syntax and ACID-compliant operations. ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure MySQL instance in minutes—no need to install or manage dependencies. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes MySQL Server, default admin credentials, and optimized system settings.  ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "root",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Connect using:  ",
      command: "-u root -p -h <YOUR_INSTANCE_IP> ",
    },
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: " /etc/mysql/mysql.conf.d/mysqld.cnf  ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses:",
      list: ["3306 "],
    },
    note: "Note : Find the configuration file at /etc/mysql/mysql.conf.d/mysqld.cnf for customized tweaks or backup. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaDatabase,
        title: "SQL Compliance",
        text: "Fully supports ANSI SQL with extensive support for joins, views, triggers, and stored procedures.",
      },
      {
        icon: FaExchangeAlt,
        title: "Replication",
        text: "Offers master-slave and group replication for scalability and redundancy.",
      },
      {
        icon: FaCogs,
        title: "Pluggable Storage Engines",
        text: "Supports InnoDB for ACID compliance, along with others like MyISAM and Memory.",
      },
      {
        icon: FaBolt,
        title: "Fast Read Performance",
        text: "Efficient indexing and caching mechanisms provide high-speed query execution.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or native tools like mysqldump, mysqlpump. ",
      },
      {
        label: "Security Out of the Box",
        text: " Hardened with firewall rules, TLS support, and user privilege controls. ",
      },
      {
        label: "Scalable Architecture",
        text: "Horizontal and vertical scaling supported; ideal for high-load applications. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "MySQL Official Docs",
    docsLink: "https://dev.mysql.com/doc/",
  },
};
